<template>
	<div>
	  <SubTopNav title="Search"  />
	  <div class="content">
	  	<div class="search-bar">
			<b-form-input v-model="searchWord" placeholder="Search..." @change="searchSite()"></b-form-input>
			<b-button type="submit" variant="success" @click="searchSite"><i class="fas fa-search"></i></b-button>
		</div>
	  	<h3>Results <span v-if="searchWord">for `{{ searchWord }}`</span></h3>
	  	<div class="result-count">{{ searchResultsLength }} <span v-if="searchResultsLength != null">items</span></div>	
	  	<div class="loading" v-if="searchResultsLength == null">
	  		<i class="fas fa-spinner fa-spin fa-3x"></i>
	  	</div>	
	  	<div class="filter-results" v-if="searchResultsLength != null">
			<b-button-group>
		      <b-button v-for="(type, index) in searchTypes" :key="index" :variant="(showItems == type.key) ? 'success' : ''" @click="filterResults(type.key)">{{ type.label }}</b-button>
		      
		    </b-button-group>
	    </div>
	  	<div v-for="(result, index) in searchResults" :key="index" class="search-result animated fadeInUp" v-show="(result.type == showItems) ||  showItems == 'all'" @click="getResult(result)">
	  		<h6>{{ result.title }}</h6>
	  		<p v-html="result.summary">...</p>
	  	</div>
	  	<div v-if="searchResultsLength == 0" class="no-results">Your search did not locate any results.</div>
	  </div>
	  
  </div>
</template>
<script>
// @ is an alias to /src
	import SubTopNav from "@/components/SubTopNav.vue";
	import { RepositoryFactory } from "@/repositories/RepositoryFactory"
  	const ContentRepository = RepositoryFactory.get("content");

	export default {
	  name: "about",
	  components: {
	    SubTopNav
	  },
	  data: function(){
	  	return {
	  		content: null,
	  		image: null,
	  		title: null,
	  		searchWord: null,
	  		searchResults: [],
	  		searchResultsLength: null,
	  		searchTypes: [
	  			{key: 'all', label:'All'}, 
	  			{key: 'ke', label:'Key Industries', path:"/capabilities"}, 
	  			{key: 'insight', label:'Insights', path:"/insights"}, 
	  			{key: 'practice_area', label:'Practice Areas', path:"/capabilities"}, 
	  			{key: 'person', label:'People', path:"/our-people"}, 
	  			{key: 'career', label:'Careers', path:"/careers"}
	  		],
	  		showItems: 'all'
	  	}
	  },
	  methods: {
	  	async searchSite(){
	  		this.searchResults = []
	  		this.searchResultsLength = null
	  		this.showItems = 'all'

	        const { data } = await ContentRepository.searchSite(this.searchWord)
	        this.searchResults = data
	        this.searchResultsLength = this.searchResults.length
	        // console.log('data', data)
	          
	        
	  	},
	  	getResult(result){
	  		var pathArray = this.searchTypes.filter(item => {
	  			return result.type == item.key
	  		})

	  		var path = pathArray[0].path
	  		var alias = result.link.split('/')

	        alias = alias.pop()
	  		path = path + '#' + alias

	  		this.$router.push(path)
	  	},
	  	filterResults(key){
	  		this.showItems = key
	  		var filtereredArray = this.searchResults.filter(item =>{
	  			return (item.type == this.showItems || this.showItems == 'all')
	  		})

	  		this.searchResultsLength = filtereredArray.length
	  	}
	  },
	  mounted(){
	  	this.searchWord = this.$route.query.q
	  	this.searchSite()
	  }
	};
</script>
<style scoped>
	.about{
		text-align:left;
	}

	.no-results{
		font-style: italic;
		font-weight:bold;
	}

	.result-count{
		color:green;
	}

	h3 {
		xmargin-bottom:30px;
	}

	img.leftImage {
		float:left;
	}

	.search-result{
		background:rgba(255,255,255,0.8);
		padding:20px;
		margin-bottom:15px;
		cursor:pointer;
	}

	.search-result h6{
		text-transform: uppercase;
		font-weight:bold;
	}

	.search-bar{
		margin-bottom:25px;
		display:grid;
		grid-template-columns: 1fr 80px;
	}

	.search-bar input{
		height:60px;
	}	


	.btn-group .btn, .btn-group .btn:hover, .btn-group .btn.active{
		border-radius:0;
		background:transparent;
		text-transform:uppercase;
		margin-right:3px;
		color:#333;
		border-top:0px solid #FFF;
		border-left:0px solid #FFF;
		border-right:0px solid #FFF;
		border-bottom:3px solid #333;
	}


	.btn-group .btn.btn-success{
		border-color:green;
		color:green;
	}

	.page-image img{
		max-width:100%;
	}

	.page-image{
		background-size:cover;
	}

	.square{
		width:50%;
		overflow:hidden;
	}

	.filter-results{
		xtext-align:center;
		margin-bottom:20px;
		position:relative;
		z-index:0;
	}

	.square.blue{
		clear:both;
		float:right;
		background:rgba(0,102,255,0.8);
	}

	.square.green{
		background:rgba(0,153,51,0.8);
	}

	.square.yellow{
		background:#FFFF00;
		clear:both;
		margin-bottom:20px;
	}

	.square:after {
	  content: "";
	  display: block;
	  padding-bottom: 100%;
	}

	@media (max-width: 768px){
		.filter-results{
			display:none;
		}

		.result-count{
			margin-bottom:20px;
		}
	}



</style>
